export function isCategorySelectorPanelEmpty(props) {
    return !props?.header;
}
